<app-content 
[content]="content"
[bulletList]="false"
>

</app-content>

